import React from 'react';
import { StyledBgCurve } from './styles';
import { useTheme } from 'styled-components';

export const BgCurve = () => {
  const theme = useTheme();

  return (
    <StyledBgCurve>
      <svg
        height="100%"
        preserveAspectRatio="none"
        version="1.1"
        viewBox="0 0 1600 765"
        width="100%"
        xmlnsXlink="http: //www.w3.org/1999/xlink"
      >
        <g fill="none" fillRule="evenodd" id="login" stroke="none" strokeWidth="1">
          <g fill={theme.colors.primary} id="trial">
            <path
              d={
                'M-0.452783653,312.597656 C153.66995,402.29315 341.313938,469.239492 560.290316,507.828259' +
                ' C1070.53844,597.74593 1275.51987,587 1599.54722,765 C1599.54722,765 1599.54722,510 1599.54722,0' +
                ' L-0.452783653,0 C-1.18240545,208.398437 -1.18240545,312.597656 -0.452783653,312.597656 Z'
              }
              id="curve-extended"
            />
          </g>
        </g>
      </svg>
    </StyledBgCurve>
  );
};
